var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "catalog-limiter" }, [
    _c(
      "button",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: _vm.closeListWithDelay,
            expression: "closeListWithDelay"
          }
        ],
        ref: "button",
        staticClass: "catalog-limiter__btn btn btn--small",
        on: { click: _vm.toggleList }
      },
      [
        _c("span", {
          staticClass: "catalog-limiter__label",
          domProps: { textContent: _vm._s(_vm.resultsPP) }
        }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "catalog-limiter__arrow" },
          [
            _c("SortIcon", {
              class: { "icon--rotate-180": _vm.listOpen },
              attrs: { width: "14", height: "9" }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _vm.listOpen
      ? _c(
          "div",
          {
            ref: "list",
            staticClass: "catalog-limiter__list",
            class: { "is-visible": _vm.listOpen },
            attrs: { tabindex: "0", role: "listbox" },
            on: { keydown: _vm.onKeyDown }
          },
          _vm._l(_vm.pagerOptions, function(limitOption, index) {
            return _c(
              "button",
              {
                key: index,
                staticClass: "catalog-limiter__list-item btn--clear",
                class: {
                  "is-active": _vm.resultsPP == limitOption,
                  "is-highlighted": _vm.highlightedIndex === index
                },
                attrs: { role: "option" },
                on: {
                  click: function($event) {
                    return _vm.setPerPage(limitOption)
                  }
                }
              },
              [_c("span", [_vm._v(_vm._s(limitOption))])]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }